"use client";
import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { Sparkles } from "lucide-react";
import { CardServices } from "../CardServices";
import { gsdentalServices } from "@/lib/const/services";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.4,
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeInOut" },
  },
};

export function ServicesGsdental() {
  const ref = useRef(null);
  const [isLargeScreen, setIsLargeScreen] = useState(true);

  // Hook para animaciones optimizado
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  // Detectar tamaño de pantalla
  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024); // lg breakpoint
    };

    // Verificar al montar
    checkScreenSize();

    // Escuchar cambios de tamaño
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Organizamos los servicios en filas responsive
  const organizeInRows = (services) => {
    const rows = [];
    const itemsPerRow = isLargeScreen ? 3 : 2; // 3 en laptop+, 2 en tablet/móvil

    for (let i = 0; i < services.length; i += itemsPerRow) {
      rows.push(services.slice(i, i + itemsPerRow));
    }
    return rows;
  };

  const serviceRows = organizeInRows(gsdentalServices);

  return (
    <div ref={ref} className="relative pt-8 overflow-hidden">
      <div className="px-4 relative ">
        {/* Header Section */}
        <motion.div
          className="text-center mb-14"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.div
            className="inline-flex items-center space-x-2 bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-medium mb-6"
            variants={itemVariants}
          >
            <Sparkles className="w-4 h-4" />
            <span>Servicios Especializados</span>
          </motion.div>
          <motion.h2
            className="text-5xl md:text-6xl font-bold text-title mb-6 leading-tight"
            variants={itemVariants}
          >
            Nuestros <span className="text-primary">Servicios</span>
          </motion.h2>
          <motion.p
            className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed"
            variants={itemVariants}
          >
            Ofrecemos una amplia gama de servicios dentales especializados con
            <span className="text-primary font-semibold">
              {" "}
              tecnología de vanguardia
            </span>{" "}
            y atención personalizada para cada paciente.
          </motion.p>
        </motion.div>

        {/* Services Grid optimizado - Por filas */}
        <motion.div
          className="space-y-8 pb-8"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {serviceRows.map((row, rowIndex) => (
            <motion.div
              key={rowIndex}
              className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
              variants={itemVariants}
            >
              {row.map((service, cardIndex) => (
                <CardServices service={service} key={service.id || cardIndex} />
              ))}
            </motion.div>
          ))}
        </motion.div>
        {/* <BentoGrid>
					{gsdentalServices.map((service, index) => (
						<BentoCard key={index} {...service} />
					))}
				</BentoGrid> */}
      </div>
    </div>
  );
}
